import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthSessionService } from '../services/others/auth-session.service';

export const loginGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authenticated = inject(AuthSessionService).isAuthenticated();

  if (!authenticated) {
    return true;
  }
  return router.createUrlTree(['/home-page']);
};
